export default "__VITE_ASSET__iPZSCQi6__"